/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { b as __awaiter, c as __generator, a as __rest } from '../../../tslib.es6-e01eabb2.js';
import { navigateBack } from '../../navigate-back/index.js';
import '../../../index-6f6b9acc.js';
import { d as delay } from '../../../tool-7a8f4749.js';
import { env } from '../../env/index.js';
import '../../../index-e5fa4dec.js';
import '../../extend/index.js';
import '../../extend/register/index.js';
import '../../../index-f24a9ec1.js';
import '../../../bridges/dd/index.js';
import '../../../loadscripts-cf212b8d.js';
import '../../../constants-163bd007.js';
import '../../../bridge-adpter-api-0316c034.js';
import '../../../bridges/windvane/index.js';
import '../../../bridges/nebula/index.js';
import '../../../index.es-142c5680.js';
import '../../../bridges/pangu-mini-app/index.js';
import '../../../log-aabf3a34.js';
import '../../../index-892d8eee.js';
import '../../../_commonjsHelpers-56d33373.js';
import '../../navigate-back/cn/index.js';
import '../../navigate-back/cnStation/index.js';
import '../../navigate-back/fm/index.js';
import '../../../common-42e7d8d8.js';
import '../../../safe-data-66f20265.js';
import '../../navigate-back/tm/index.js';
import '../../navigate-back/tb/index.js';
import '../../navigate-back/ali1688/index.js';
import '../../navigate-back/browser/index.js';
import '../../navigate-back/dingTalk/index.js';
import '../../navigate-back/dingTalkPC/index.js';
import '../../navigate-back/panguMiniApp/index.js';
import '../../navigate-back/mini/index.js';
import '../../../index-ee2c9aee.js';

// 兜底
function back(params) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, success, fail, delayNumber, rest, currentUrl, preUrl;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = params !== null && params !== void 0 ? params : {}, success = _a.success, fail = _a.fail, delayNumber = _a.delay, rest = __rest(_a, ["success", "fail", "delay"]);
                    currentUrl = window.location.href;
                    window.history.back();
                    return [4 /*yield*/, delay(delayNumber || 200)];
                case 1:
                    _b.sent();
                    preUrl = window.location.href;
                    if (currentUrl !== preUrl || env.isBrowser) {
                        success === null || success === void 0 ? void 0 : success({
                            message: 'window history back',
                        });
                        return [2 /*return*/];
                    }
                    // 关闭浏览器
                    navigateBack(rest).then(success).catch(fail);
                    return [2 /*return*/];
            }
        });
    });
}

export { back as default };
